var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"alert",class:{ fadeOut: _vm.isFadeOut },on:{"animationend":_vm.onAnimationEnd}},[_c('i',{staticClass:"iconfont icon-fankui-weikaifang"}),_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }